export const DEFAULT_DATE_TIME_STRING = "0001-01-01T00:00:00+00:00";

export enum TimeFormats {
  LongDate = "LL",
  ShortDate = "L",
  ShortTime = "LT",
}

export const languageCodeToMomentLocaleFile: {
  [key: string]: string | null;
} = {
  "ar-SA": "ar-sa",
  "bg-BG": "bg",
  "cs-CZ": "cs",
  "da-DK": "da",
  "de-DE": "de",
  "el-GR": "el",
  "en-GB": "en-gb",
  // This is a special case because en-US is the default
  "en-US": null,
  "es-ES": "es",
  "et-EE": "et",
  "fi-FI": "fi",
  "fr-CA": "fr-ca",
  "fr-FR": "fr",
  "he-IL": "he",
  "hr-HR": "hr",
  "hu-HU": "hu",
  "id-ID": "id",
  "it-IT": "it",
  "ja-JP": "ja",
  "ko-KR": "ko",
  "lt-LT": "lt",
  "lv-LV": "lv",
  "nb-NO": "nb",
  "nl-NL": "nl",
  "pl-PL": "pl",
  "pt-BR": "pt-br",
  "pt-PT": "pt",
  "ro-RO": "ro",
  "ru-RU": "ru",
  "sk-SK": "sk",
  "sl-SI": "sl",
  "sr-Latn-RS": "sr",
  "sv-SE": "sv",
  "th-TH": "th",
  "tr-TR": "tr",
  "uk-UA": "uk",
  "vi-VN": "vi",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
};
